import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "google-logo-drive",
  "use": "google-logo-drive-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"google-logo-drive\"><path d=\"M15.63 9.893L10.518 1H5.481l5.112 8.893h5.037zm-9.334.74L3.778 15.08h9.704L16 10.634H6.296zm-1.481-8.52L0 10.634l2.519 4.446 4.888-8.522-2.592-4.446z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol